import { Clickable } from 'src/shared/design-system/Utilities';
import { VerticallyCenteredText } from 'src/shared/design-system/VerticallyCenteredText';
import styled from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Border, Colors, Font, Mixins, Spacing } from 'web-common/src/shared/styles';

export const Button = styled(Clickable)<{ selected?: boolean }>`
  background: ${ifProp('selected', Colors.KOHLRABI_LITE_40, Colors.WHITE)};
  border: ${Border.Base} ${ifProp('selected', Colors.KOHLRABI, Colors.GRAY_LITE_10)};
  border-radius: ${Border.Radius.M};
  padding: ${Spacing.SINGLE};

  ${Mixins.Media.minWidthLarge(`
    width: auto;
  `)}

  ${Mixins.Media.maxWidthMedium(`
    width: calc(33% - ${Spacing.HALF});
  `)}

  ${Mixins.Media.maxWidthSmall(`
    width: calc(50% - ${Spacing.HALF});
  `)}
`;

export const ButtonWrapper = styled.div<{ flexDirection?: 'row' | 'column' }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${Spacing.HALF};

  flex-direction: ${({ flexDirection = 'row' }) => flexDirection};

  ${Mixins.Media.maxWidthSmall(`
    flex-direction: column;
  `)}
`;

export const Label = styled(VerticallyCenteredText)`
  color: ${Colors.GRAY_DARK_30};
  font-size: ${Font.Size.S};
  font-weight: ${Font.Weight.SEMI_BOLD};
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: ${Spacing.DOUBLE};
  height: ${Spacing.DOUBLE};
  width: ${Spacing.DOUBLE};
  & svg {
    height: ${Spacing.SINGLE};
    width: ${Spacing.SINGLE};
  }

  ${Mixins.Media.maxWidthSmall(`
    border-radius: ${Spacing.TRIPLE};
    height: ${Spacing.QUINTUPLE};
    width: ${Spacing.DOUBLE};
    & svg {
      height: ${Spacing.SINGLE_HALF};
      width: ${Spacing.SINGLE_HALF};
    }
  `)}
`;
